import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ContactHero from './components/ContactHero';
import ContactMethods from './components/ContactMethods';
import ProjectInquiryForm from './components/ProjectInquiryForm';
import TeamAvailability from './components/TeamAvailability';
import OfficeLocation from './components/OfficeLocation';
import ContactCTA from './components/ContactCTA';

const Contact = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact Us - Shutter Lifters | Start Your Digital Transformation</title>
        <meta 
          name="description" 
          content="Contact Shutter Lifters for your next software development project. Get free consultation, project quotes, and expert technical advice. Multiple contact options available." 
        />
        <meta name="keywords" content="contact, software development, consultation, project inquiry, technical support, Shutter Lifters" />
        <meta property="og:title" content="Contact Us - Shutter Lifters" />
        <meta property="og:description" content="Ready to transform your digital vision? Contact our expert team for consultation and project development." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://shutterlifters.com/contact" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          {/* Hero Section */}
          <ContactHero />
          
          {/* Contact Methods */}
          <ContactMethods />
          
          {/* Project Inquiry Form */}
          <ProjectInquiryForm />
          
          {/* Team Availability */}
          {/* <TeamAvailability /> */}
          
          {/* Office Locations */}
          <OfficeLocation />
          
          {/* Final CTA */}
          <ContactCTA />
        </main>
      </div>
    </>
  );
};

export default Contact;